import { injectDynamicFees } from './dynamicPrices';

/**
 * @param cards to pull from
 * @param isToggle2Data is transport toggle secondary data
 * @returns array of card channel counts in 'n+' format, for the pkg comparison modal
 */
export const getChnlCountsFromCtaLabel = (cards: any, isToggle2Data?: boolean) => {
  const stripForCount = (label: string): string => {
    const stripped = label?.replace(/<[^>]*>/g, '')?.match(/\d+/g) || "";
    if (stripped?.length) {
      return `${stripped?.[stripped?.length - 1]}+`;
    }
    return ""
  }

  // strip html for last number set in string, or use default count value
  return cards?.map(card => {
    if (isToggle2Data) {
      if (card?.toggle2PlanCardData?.seeAllChannelsCta?.label) {
        return stripForCount(card?.toggle2PlanCardData?.seeAllChannelsCta?.label);
      }
      return ""
    }
    let newStrip = stripForCount(card?.seeAllChannelsCta?.label);
    if (newStrip?.length) {
      return newStrip;
    }
    newStrip = stripForCount(card?.seeAllChannelsSecondCta?.label);
    if (newStrip?.length) {
      return newStrip;
    }
    newStrip = card?.comparePackagesCta?.count;
    if (newStrip?.length) {
      return newStrip;
    }
    return ""
  });
};

/**
 * Feature discontinued
 */
export const getPriceCopyFromCardSet = (cards: any[], feeMaps: any[]) => cards?.map((card: any, ix: number) => injectDynamicFees(
  card?.productPrice?.priceCopy?.[0]?.content?.toString() ||
      card?.productPrice?.priceCopy?.content?.toString() ||
      "",
  feeMaps?.[ix]
))
